const en = {
  common: {
    wallet: "wallet",
    playPage: "play",
    minTop: "min amount is $10",
    maxTop: "max amount is $500",
    website: "website",
    signOut: "sign out",
    hidden: "hidden",
    victory: "victory",
    wentWrong: "something went wrong, redirecting",
    stakeLabel:  "stake",
    howDoes:  "how does this work?",
    continue: "Continue",
    continueWithGoogle: "Continue with Google",
    continueWithApple: "Continue with Apple",
    termsOfService: "terms of service",
    privacyPolicy: "privacy policy",
    termsOfServiceFooter: "terms of service",
    privacyPolicyFooter: "privacy policy",
    verificationCode: "verification code",
    verify: "verify",
    account: "account",
    error: "an error occurred\n",
    checkBackLater: "check back later",
    looking: "looking...",
    yes: "yes",
    no: "no",
    pleaseSelect: "Please select\n",
    disclaimer: "by continuing you agree to our\n",
    and: "and",
  },
  endOfGame: {
    wonByCheckmate: "won by checkmate",
    lostOnTime: "lost on time",
    resigns: "resigns",
    gameDrawnByAgreement: "game drawn by agreement",
    abandonedTheGame: "abondoned the game",
    gameAborted: "game aborted",
    gameDrawnByStalemate: "game drawn by stalemate",
    gameDrawnByFiftyMoveRule: "game drawn by fifty move rule",
    gameDrawnByInsufficientMaterial: "game drawn by insufficient material",
    gameDrawnByThreefoldRepetition: "game drawn by threefold repetition",
    draw: "draw",
    victory: "victory",
    defeat: "defeat",
    aborted: "aborted",
    white: "white",
    black: "black",
    inspectBoard: "view board",
    returnToEndOfGameModal: "continue",
  },
  byPhone:{
    continueOnPhone: "continue on\nphone",
    or: "or",
    continueOnWeb: "continue in\nyour browser",
    disclaimer: "suitable if you have a picture of your ID on disk"
  },
  signUp: {
    email: "email",
    username: "username",
    usernameInvalid: "username invalid",
    emailInvalid: "invalid email",
    login: "login",
    continueWithPhone: "continue with phone number",
    tickBoxes: "let's tick some\nboxes",
    confirm: "I confirm that\n",
    resideIn: "I reside in\n",
    notPEP: "I am not a politically exposed person (PEP), a family member or a know associate of a PEP\n",
    purpose: "The purpose and nature of my relationship with Gambit is solely to use the service for entertainment\n",
    soleBenefit: "I will use the service solely for the benefit of myself and that there is no other beneficial owner\n",
  },
  identity: {
    beingVerified: "identity\nis being verified",
    verified: "verified\n",
    failed: "verification\nfailed",
  },
  payment: {
    failed: "payment failed.\nplease try again",
    successful: "payment\nsuccessful!",
    toppedUp: "you're\ntopped up!",
    topUp: "top-up\n",
    payWith: "pay with...\n",
  },
  gameplay: {
    play: "play\n",
    challenge: "challenges you to a",
    gameWorth: "game worth\n",
    whatsYourNumber: "what's your\nnumber?",
    receiveCode: "you'll receive a verification\ncode shortly",
    matchedOpponent: "You will be matched against an opponent with a similar rating.",
    stake: {
      total: "The total stake will be the amount selected below.",
      contribution: "You will contribute roughly half of that amount.",
      weakerOpponent: "If you are matched against a weaker opponent, you will pay a bigger share of the stake.",
      strongerOpponent: "If you are matched against a stronger opponent, you will pay a smaller share of the stake.",
    },
    supportInfo: "Visit our support for more information.\n",
    continueBrowser: "continue in\nyour browser",
    continuePhone: "continue on\nphone",
    getStarted: "let's get\nstarted",
    sentText: "we've sent you\na text",
    enterReceivedCode: "enter the received\nverification code",
    wrongCode: "wrong code, try again\n",
    secPerMove: "sec/move",
    resign: {
      prompt: "are you sure you want to resign?",
    },
    draw: {
      offer: "accept draw offer?",
    },
    rating: "rating\n",
    balance: "balance\n",
    rematch: "rematch\n",
    newOpponent: "new opponent\n",
    home: "home\n",
    rematchOffer: "your opponent offers a rematch. accept?",
    leaveGame: "You are currently playing a game. Are you sure you want to leave?",
    room: "room:\n",
    gameTypes: {
      bullet: {
        title: "bullet\n",
        description: "Adrenaline chess. You and your opponent are given only 1 minute each to win the game.",
      },
      blitz: {
        title: "blitz\n",
        description: "You and your opponent are given 3 minutes each to win the game.",
      },
    },
    stakes: {
      unlockNext: "play {amount} more games to unlock the next stake",
      allUnlocked: "you've unlocked all stakes",
    },
    withdraw: "withdraw\n",
  },
  puzzle: {
    begin: "begin",
    next: "next",
    unavailableInYourRegion: "unavailable",
    puzzle: "puzzle",
    whiteToPlay: "white to move",
    blackToPlay: "black to move",
    time: "time",
    solution: "solution",
    somethingWentWrong: "something went wrong",
    rating: "rating",
    credits: "credits",
    puzzleFailed: "loss",
    puzzleSolved: "win",
    correct: "correct solution",
    incorrect: "incorrect solution",
    youRanOutOfTime: "you ran out of time",
    puzzleDescription: "You have 10 seconds + 2 seconds/move to solve a puzzle.",
    creditsLeft: "credits left",
    refillIn: "refill in",
    lastPuzzle: "This is your last puzzle, check back later for more.",
    outOfCredits: "You've run out of credits, check back later.",
    locationPrompt: "We need your location to proceed. If blocked, please re-enable it:",
    locationInstructions: "Click the icon in the address bar, select 'Always allow' and refresh the page",
    creditsError: "Error loading credits",
    moves: "Moves:",
  },
};

export {en};